// User = Role
import {
  AddRoleResponse,
  // RoleCommonResponse,
  RoleError,
  Role,
  RoleResponse,
  DeletedRole,
} from '@core/interface/roles';
import { PagePayload } from '@core/interface/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const RoleActions = createActionGroup({
  source: 'Role',
  events: {
    'Load Roles': emptyProps(),
    'Load Roles Success': props<RoleResponse>(),
    'Load Roles Failure': props<RoleError>(),
    'Add Edit Role': props<{ role: Role }>(),
    'Add Role Success': props<AddRoleResponse>(),
    'Update Role Success': props<AddRoleResponse>(),
    'Add Role Failure': props<RoleError>(),
    'Update Role Failure': props<RoleError>(),
    'Delete Role': props<{ id: number }>(),
    'Delete Role Success': props<DeletedRole>(),
    'Delete Role Failure': props<RoleError>(),
  },
});
